import { Component } from 'react';
import ErrorMessageRefreshPage from './ErrorMessageRefreshPage';
import Raven from 'raven-js';
import { isFunction } from '../utils/function';
import { jsx as _jsx } from "react/jsx-runtime";
class ErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error, errorInfo) {
    const {
      errorBoundaryName = '[ABLibErrorBoundary]',
      appName = '',
      onComponentDidCatch
    } = this.props;
    Raven.captureException(new Error(`[AB Shared Lib] Error Boundary for ${errorBoundaryName}`, {
      cause: error
    }), {
      extra: {
        error,
        errorInfo
      },
      tags: {
        appName,
        errorBoundaryName
      }
    });
    if (isFunction(onComponentDidCatch)) {
      onComponentDidCatch({
        error,
        errorInfo
      });
    }
  }
  render() {
    const {
      hasError
    } = this.state;
    if (hasError) {
      return /*#__PURE__*/_jsx(ErrorMessageRefreshPage, {});
    }
    return this.props.children;
  }
}
export default ErrorBoundary;